import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Project } from '../../core/interfaces/Project';
import { BackendService } from '../../core/services/backend.service';

@Directive()
export abstract class SolutionBase implements AfterViewInit {
  carouselItems: Project[] = [];

  constructor(
    protected router: Router,
    protected el: ElementRef,
    protected backendService: BackendService
  ) {}

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'instant' });
    this.backendService.getProjects().subscribe(items => {
      this.carouselItems = items.data;
    });
  }

  goToUrl(url: string): void {
    this.router.navigate(['/' + url]);
  }

  ngAfterViewInit(): void {
    const cards = this.el.nativeElement.querySelectorAll('.card');

    window.addEventListener('mousemove', (ev: MouseEvent) => {
      cards.forEach((card: HTMLElement) => {
        const blob = card.querySelector('.blob') as HTMLElement;
        const fblob = card.querySelector('.fakeblob') as HTMLElement;
        const rect = fblob.getBoundingClientRect();

        blob.animate(
          [{ transform: `translate(${ev.clientX - rect.left - rect.width / 2}px, ${ev.clientY - rect.top - rect.height / 2}px)` }],
          { duration: 300, fill: 'forwards' }
        );

        const dx = ev.clientX - (rect.left + rect.width / 2);
        const dy = ev.clientY - (rect.top + rect.height / 2);
        const distance = Math.sqrt(dx * dx + dy * dy);
        const maxDist = Math.max(window.innerWidth, window.innerHeight) / 2;
        blob.style.opacity = `${1 - Math.min(distance / maxDist, 1)}`;
      });
    });
  }
}
